import { Component } from 'preact';
import { html } from '../../helpers/preact-html';

class MobileNavigationPage extends Component {
  renderHeading({ label }) {
    return html` <div class="label">${label}</div> `;
  }

  renderLink({ label, id, href, children, badge, highlight }) {
    const { onSelectSubmenu } = this.props;

    const onLinkClick =
      !href || href.length === 0
        ? (e) => {
            e.preventDefault();
            onSelectSubmenu(id);
          }
        : null;

    return html`
      <div
        class="navigation-page-item ${highlight &&
        'navigation-page-item-ishighlighted'}"
        key=${id}
      >
        <a
          class="link-nostyle"
          href=${href ? href : '#'}
          onClick=${onLinkClick}
        >
          <span>
            ${label}
            ${badge &&
            badge.length > 0 &&
            html`<span class="navigation-page-badge label">${badge}</span>`}
          </span>
        </a>
        ${children &&
        children.length &&
        html`
          <button
            type="button"
            class="button button-icon button-tertiary button-icon-mediumicon"
            aria-label="Navigiere zu '${label}'"
            data-trigger="nav"
            onClick=${() => onSelectSubmenu(id)}
          >
            <i class="ri-arrow-right-s-line" aria-label="Pfeil nach rechts"></i>
          </button>
        `}
      </div>
    `;
  }

  renderBackButton() {
    const { onNavigateBack } = this.props;
    return html`
      <button class="navigation-page-backbutton" onClick=${onNavigateBack}>
        <i class="ri-arrow-left-line" aria-hidden="true"></i>
        <div>Zurück</div>
      </button>
    `;
  }

  render({ navPage, onNavigateBack }) {
    return html`
      <div class="navigation-page">
        ${this.renderBackButton()}
        <h3>${navPage.label}</h3>
        ${navPage.children.map((child) =>
          child.type === 'heading'
            ? this.renderHeading(child)
            : this.renderLink(child),
        )}
      </div>
    `;
  }
}

export { MobileNavigationPage };
